/**
 * Recipient scoping for realtime notifications.
 *
 * A notification's `recipient_user_ids` (when present and non-empty) restricts
 * it to those users; an absent or empty list means "all org users". This is the
 * client-side mirror of the server's recipient filter
 * (`_should_include_notification_for_user` in
 * `services/api/routes/organizations/_notification_inbox.py`). It lives in a
 * plain, dependency-free module so both the web app hook and the Chrome
 * extension service worker can apply identical scoping.
 */

export function isNotificationRecipient(
    recipientUserIds: unknown,
    userId: string | null,
): boolean {
    if (!Array.isArray(recipientUserIds) || recipientUserIds.length === 0) {
        return true;
    }

    if (userId === null) {
        return false;
    }

    return recipientUserIds.some(
        (recipientUserId) =>
            typeof recipientUserId === 'string' && recipientUserId === userId,
    );
}
